import { z } from "zod";

import { BRAND_MARKUP } from "../../constants";
import { defineModel } from "../types";

// TODO: Verify ElevenLabs pricing - assumed ~$0.30 per 1K characters (varies by plan)
const COST_PER_CHAR_MICRODOLLARS = 0.0003 * 1_000_000;

const elevenlabsTTSParams = z
  .object({
    voiceId: z.string().default(""),
    prompt: z.string().default(""),
    stability: z.number().min(0).max(1).optional(),
    similarityBoost: z.number().min(0).max(1).optional(),
  })
  .strip();

export const elevenlabsTTS = defineModel({
  key: "elevenlabs-tts",
  stepType: "tts",
  spec: {
    label: "ElevenLabs",
    description:
      "High-quality text-to-speech with natural voices and word timestamps",
    icon: "elevenlabs-icon.svg",
    tags: ["elevenlabs"],
    features: { prompts: true } as const,
    options: {
      voice: {
        items: [], // Populated dynamically from API
      },
    },
    params: elevenlabsTTSParams,
  },
  providers: [
    {
      provider: "elevenlabs",
      modelId: "elevenlabs-tts",
      estimateCost(params) {
        const charCount = (params.prompt ?? "").length;
        return Math.round(
          charCount * COST_PER_CHAR_MICRODOLLARS * (1 + BRAND_MARKUP),
        );
      },
      toPayload(params) {
        return {
          text: params.prompt ?? "",
          voiceId: params.voiceId ?? "",
          stability: params.stability,
          similarityBoost: params.similarityBoost,
        };
      },
    },
  ],
});
